import React, {Component} from 'react';
import {connect} from "react-redux";
import {setAway,setDarkMode,logout} from "../actions/actions";
import BModal from "./BModal";

import {
    Link
} from "react-router-dom";
import {titleAddMessageCount,unreadMessageCount} from "../lib/helper";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class LeftMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
			checked: this.props.chatprop.operator['away']==1 ? true : false,
			checkedDarkMode: this.props.chatprop.operator['dark_mode']==1 ? true : false
		}
        this.changeSetAway = this.changeSetAway.bind(this);
        this.changeSetDarkMode = this.changeSetDarkMode.bind(this);
        this.logout = this.logout.bind(this);


    }


    logout(){
        this.props.dispatch(logout());
    }
    changeSetAway(e){
        this.setState({
            checked: e.target.checked
        })
        this.props.dispatch(setAway(e.target.checked));

    }
	
	changeSetDarkMode(e){
        this.setState({
            checkedDarkMode: e.target.checked
        })
        this.props.dispatch(setDarkMode(e.target.checked));

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        titleAddMessageCount({
           prop:this.props.chatprop
        });

    }

    render() {
        const {t} = this.props;

        var menuArr = [];

        let left_menu=this.props.chatprop.left_menu;
        let url=this.props.chatprop.url;
        Object.keys(left_menu).map((key, menu) => {
            if(key=="chat"){
                var unreadMessage=unreadMessageCount(this.props.chatprop);

                if(unreadMessage>10){
                    unreadMessage=unreadMessage+"+";
                }

            }
            menuArr.push(
                <li className={""+this.props.chatprop.selected_menu==left_menu[key].href ? "active" : ""}>
                    <Link to={"/"+left_menu[key].href}>
                        <span>
                              <i className={left_menu[key].icon_class}></i>
                            {key == "chat" && unreadMessage!=0 &&
                                <div className="chat-unread-mesage">{unreadMessage}</div>
                            }
                             <div className="menu-title">{left_menu[key].name}</div>
                        </span>

                    </Link>

                </li>
            );
        });



        return (
            <React.Fragment>
                <BModal size="lg" />
                <div className="sidebar-menu">
                    <div className="logo-col">

                    </div>
                    <div className="menus-col">
                        <div className="chat-menus">
                            <ul>
                                {menuArr}
                            </ul>
                        </div>
                        <div className="bottom-menus">
                            <ul>
                                <li className="settings-control">
                                    <label className="switch">
                                        <input type="checkbox"
                                               className="setDarkMode"
                                               checked={this.state.checkedDarkMode}
                                               onChange={this.changeSetDarkMode}  />
                                        <span className="slider round"></span>
                                    </label>
                                    <div>
                                        <span>Dark Mode</span>
                                    </div>
                                </li>
								<li className="settings-control">
                                    <label className="switch">
                                        <input type="checkbox"
                                               className="setAway"
                                               checked={this.state.checked}
                                               onChange={this.changeSetAway}  />
                                        <span className="slider round"></span>
                                    </label>
                                    <div>
                                        <span>Meşgul</span>
                                    </div>
                                </li>
                                <li>
                                    <a href="#" className="chat-profile-icon" data-toggle="dropdown">
                                        <div className="avatar mr-0">
                                            <div className="letter-avatar left-menu-avatar">
                                                {this.props.chatprop.operator['first_letter']}
                                            </div>
                                        </div>
                                    </a>

                                    <div className="dropdown-menu dropdown-menu-right" x-out-of-boundaries="">
                                        <a className="dropdown-item" onClick={this.logout}>Logout <i className='bx bx-power-off'></i></a>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default LeftMenu;
